<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="商品名称" prop="goodsName">
        <el-input v-model.trim="queryParams.goodsName" clearable @keyup.enter.native="handleQuery"
          placeholder="请输入商品名称" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="商品编号" prop="goodsSn">
        <el-input v-model.trim="queryParams.goodsSn" clearable @keyup.enter.native="handleQuery"
          placeholder="请输入商品编号" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="单品编号" prop="spuSn">
        <el-input v-model.trim="queryParams.spuSn" clearable @keyup.enter.native="handleQuery" placeholder="请输入单品编号" />
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermission="['inventory:entry:list']" size="mini" type="primary" plain icon="el-icon-sold-out"
          @click="$router.push({ name: 'inventoryEntryManage' })">入库</el-button>
        <div class="fr">
          <span class="field">库存预警邮件通知</span>
          <el-switch v-model="inventoryEmailWarning" @change="handleInventoryEmailWarningChange">
          </el-switch>
        </div>
      </div>
      <div class="table-box">
        <auto-height-table :class="{ empty: list.length === 0 }" empty-text=" " v-loading="loading"
          :data="list">
          <el-table-column label="商品信息" prop="goodsName" align="left" min-width="256px">
            <template slot-scope="scope">
              <div class="goods-info flex-c-s">
                <div class="goods-info-left">
                  <img @click.stop="
                    mixinHandlePreview(
                      scope.row.goodsImgs && scope.row.goodsImgs.split(',')
                    )
                    " :src="mixinGetImg(scope.row.goodsImgs && scope.row.goodsImgs.split(',')[0])
                      " width="40px" height="40px" alt="商品图片" />
                </div>
                <div class="goods-info-right flex-c-c flex-col">
                  <div class="top">
                    <span class="label">名称：</span>
                    <span class="value">{{ scope.row.goodsName }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">编号：</span>
                    <el-link v-if="mixinHasPermi(['inventory:statistics:list'])" type="primary"
                      @click="handleGo('goodsSn', scope.row.goodsSn)">{{ scope.row.goodsSn }}</el-link>
                    <span v-else  class="value">{{ scope.row.goodsSn }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="规格信息" prop="skuListStr" align="left" min-width="256px">
            <template slot-scope="scope">
              <div class="goods-info-right flex-c-c flex-col">
                <div class="top">
                  <span class="label">规格：</span>
                  <span class="value">{{ scope.row.skuListStr }}</span>
                </div>
                <div class="bottom">
                  <span class="label">编号：</span>
                  <el-link v-if="mixinHasPermi(['inventory:statistics:list'])" type="primary"
                    @click="handleGo('spuSn', scope.row.spuSn)">{{ scope.row.spuSn }}</el-link>
                  <span v-else  class="value">{{ scope.row.spuSn }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="当前库存" prop="spuNumber" align="center" min-width="128px" />
          <el-table-column label="预警库存" prop="inVentoryAlertNum" align="center" min-width="128px" />
          <el-table-column label="库存差额" prop="addSpuNumber" align="center" min-width="128px" />
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>
  </div>
</template>

<script>
import { statisticsApi } from "@/api"
import { debounce } from "vue2-element-admin-plugin"
export default {
  name: "inventorySpuWarningManage",
  data() {
    return {
      inventoryEmailWarning: false, // 是否开启邮件通知
      //搜索条件参数
      queryParams: {
        goodsName: "", // 商品名称
        goodsSn: "", // 商品编号
        spuSn: "", // 单品编号
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      loading: false,
      total: 0,
      isBtnTrigger: false, // 是否触发了按钮
      currentTotal: 0 // 记录旧的总数 总数变了的时候 刷新角标
    }
  },
  async created() {
    this.inventoryEmailWarning = this.mixinUserInfo.inventoryEmailWarning === "1" // 是否过期预警邮件通知
    //获取列表
    this.getList()
  },
  methods: {
    // 开启邮件通知
    handleInventoryEmailWarningChange: debounce(function(val) {
      const inventoryEmailWarning = val ? "1" : "0"
      if (inventoryEmailWarning === this.mixinUserInfo.inventoryEmailWarning) {
        return
      }
      const msg = val ? "库存预警邮件通知开启成功" : "库存预警邮件通知关闭成功"
      statisticsApi
        .changeInventoryEmailWarning({ inventoryEmailWarning })
        .then((res) => {
          // 设置用户过期预警信息
          this.$store.commit("user/SET_USER_INFO", {
            ...this.mixinUserInfo,
            inventoryEmailWarning
          })
          this.$message.success(msg)
        })
    }, 800),
    // 点击前往库存统计查询
    handleGo(key, value) {
      if (!this.mixinHasPermi(["inventory:statistics:list"])) {
        return
      }
      this.$router.push({
        name: "inventoryStatisticsManage",
        query: {
          [key]: value
        }
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.isBtnTrigger = true // 点击按钮触发的搜索
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.wareHouseId = []
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询列表 */
    getList() {
      this.loading = true
      statisticsApi
        .getSpuWarningList(this.queryParams)
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          if (this.isBtnTrigger) {
            if (this.total !== this.currentTotal) {
              this.$store.dispatch("user/getUserInfo").then(data => {
                this.currentTotal = this.total
              })
            }
          } else { // 第一次渲染直接赋值
            this.currentTotal = response.currentTotal
          }
          
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.field {
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
}

.total-box {
  padding: 24px;
  font-size: 18px;
  background: #fff;
  border-radius: 4px;
  margin-top: 12px;

  .money-info {
    margin-right: 60px;
  }
}
</style>